import React from 'react';
import { useNotifications, NotificationCategory } from '../../context/NotificationContext';

export const NotificationFilters: React.FC = () => {
  const { filters, setFilters, clearFilters, filterCounts } = useNotifications();

  // Toggle unread-only filter
  const toggleUnreadOnly = () => {
    setFilters({ ...filters, showUnreadOnly: !filters.showUnreadOnly });
  };

  // Toggle type filter (multi-select with OR logic)
  const toggleType = (type: NotificationCategory) => {
    const currentTypes = filters.types;
    if (currentTypes.includes(type)) {
      // Remove type
      setFilters({ ...filters, types: currentTypes.filter(t => t !== type) });
    } else {
      // Add type
      setFilters({ ...filters, types: [...currentTypes, type] });
    }
  };

  // Check if any filters are active (not at defaults)
  // Default is showUnreadOnly: false (show all), types: []
  // So filters are "active" when showing unread only OR when types are selected
  const hasActiveFilters = filters.showUnreadOnly || filters.types.length > 0;

  // Check if a type is active
  const isTypeActive = (type: NotificationCategory) => filters.types.includes(type);

  // Button styles
  const pillButtonStyle = (active: boolean): React.CSSProperties => ({
    background: active ? '#2563eb' : '#e2e8f0',
    color: active ? '#ffffff' : '#475569',
    fontSize: '13px',
    fontWeight: 500,
    padding: '6px 12px',
    borderRadius: '16px',
    border: 'none',
    cursor: 'pointer',
    marginRight: '8px',
    transition: 'all 0.15s ease',
  });

  const clearButtonStyle: React.CSSProperties = {
    background: 'none',
    border: 'none',
    color: '#dc2626',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
    padding: '6px 8px',
    marginLeft: 'auto',
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '4px',
        padding: '12px 16px',
        backgroundColor: '#f8fafc',
        borderBottom: '1px solid #e2e8f0',
      }}
    >
      {/* Unread Only toggle */}
      <button
        onClick={toggleUnreadOnly}
        style={pillButtonStyle(filters.showUnreadOnly)}
        title="Show only unread notifications"
      >
        Unread Only
      </button>

      {/* Separator */}
      <span
        style={{
          width: '1px',
          height: '20px',
          backgroundColor: '#cbd5e1',
          marginRight: '8px',
        }}
      />

      {/* Type filters with counts */}
      <button
        onClick={() => toggleType('bookings')}
        style={pillButtonStyle(isTypeActive('bookings'))}
      >
        Bookings ({filterCounts.bookings})
      </button>
      <button
        onClick={() => toggleType('invoices')}
        style={pillButtonStyle(isTypeActive('invoices'))}
      >
        Invoices ({filterCounts.invoices})
      </button>
      <button
        onClick={() => toggleType('messages')}
        style={pillButtonStyle(isTypeActive('messages'))}
      >
        Messages ({filterCounts.messages})
      </button>

      {/* Clear All Filters button - only visible when filters active */}
      {hasActiveFilters && (
        <button onClick={clearFilters} style={clearButtonStyle}>
          Clear All
        </button>
      )}
    </div>
  );
};

export default NotificationFilters;
